import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, defer } from 'rxjs';
import { ServicesDataConfiguration } from '../../data-config/services-data-config';
import { LocalStorageService } from '../global/local-storage.service';
import {QuickPayC} from "../../models/quickpay-c.model";
import {WafCaptchaService} from "../waf/waf-captcha.service";
import {DataSharingService} from "../login-page/data-sharing.service";

const httpOptions = {
  params: new HttpParams()
    .set('t', new Date().getTime())
    .set('ts', new Date().getTime()),
};

@Injectable({
  providedIn: 'root',
})
export class OBPPQuickPayService {
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private dataSharingService: DataSharingService,
    private wafCaptchaService: WafCaptchaService,
  ) {}

  servicesDataConfiguration = new ServicesDataConfiguration();

  quickPayData: any = [];
  selectedInvoice: string = '';

  getQuickPayData() {
    return this.quickPayData;
  }

  getSelectedInvoice() {
    return this.selectedInvoice;
  }

  async checkSDKLoaded() {
    return new Promise<void>((resolve) => {
      const interval = setInterval(() => {
        if (this.wafCaptchaService.sdkLoaded()) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  getAccountInfoByDetailsWithCaptcha(
    accNumber: string,
    invoiceNumber: string,
    postCode: string
  ): Observable<any> {
    const quickPayUrl: string = this.servicesDataConfiguration.accountInfoQuickPay;

    const payload: QuickPayC = {
      accountNumber: accNumber,
      invoiceNumber: invoiceNumber,
      postalCode: postCode,
      locale: this.localStorageService.get('lang') || 'en'
    };
    const base = this.servicesDataConfiguration.apiBaseURL.replace(/\/+$/, '');
    const path = quickPayUrl.replace(/^\/+/, '');
    const url = `${base}/${path}`;

    return defer(() =>
      this.wafCaptchaService
        .wafFetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(r => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
    );
  }

  getAccountInfoByDetails(
    accNumber: string,
    invoiceNumber: string,
    postCode: string
  ): Observable<any> {
    const quickPayUrl: string = this.servicesDataConfiguration.accountInfoQuickPay;

    const payload: QuickPayC = {
      accountNumber: accNumber,
      invoiceNumber: invoiceNumber,
      postalCode: postCode,
      locale: this.localStorageService.get('lang') || 'en'
    };

    return this.http.post(
      this.servicesDataConfiguration.apiBaseURL + quickPayUrl,
      payload
    );
  }

  getQuickPaySecurityAudit(data: any) {
    let lang = this.localStorageService.get('lang');
    let s_url = this.servicesDataConfiguration.quickpay_security_audit.replace(
      'LANG_AUTH',
      lang
    );
    return this.http.post(
      this.servicesDataConfiguration.apiBaseURL + s_url,
      data,
      httpOptions
    );
  }
}
